import { FC } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import Loading from './Loading';

const StyledLoadingOverlay = styled.div`
  ${tw`absolute flex justify-center items-center bg-white w-full h-full top-0 left-0 opacity-65 z-50 pointer-events-none`};
`;

interface Props {
  borderRadius?: 'rounded-lg' | 'rounded-xl' | 'rounded-2xl' | 'rounded-3xl';
  className?: string;
}

const LoadingOverlay: FC<Props> = ({
  borderRadius = 'rounded-lg',
  className,
}) => (
  <StyledLoadingOverlay className={`${className} ${borderRadius}`}>
    <Loading />
  </StyledLoadingOverlay>
);

export default LoadingOverlay;
